var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{class:`mdi mdi-24px mdi-${_vm.iconName}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }